import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFElectricPass from '@/components/UI/svg/mm100/Icon/EFElectricPass';
import EFPowerLoss from '@/components/UI/svg/mm100/Icon/EFPowerLoss';
import EFSafer from '@/components/UI/svg/mm100/Icon/EFSafer';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({ type = 'rv' }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.kitI`,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });
        sceneA1.on('leave', function () {
            setVideoEnterA(false);
        });

        AniContainer.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.kitI} kitI`}>
            <div className="kit-inter1">
                <div className="kit-ms1">{t('presale.product.kitI_inter1_ms1')}</div>
                <div className="kit-ms2">{type === 'rv' ? t('presale.product.kitI_inter1_ms2_rv') : t('presale.product.kitI_inter1_ms2_off_grid')}</div>
            </div>
            <div className="kit-inter2">
                <div className="kit-item kit-0">
                    <div className="kit-icon">
                        <EFElectricPass />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter2_ms2')}</div>
                </div>
                <div className="kit-item kit-1">
                    <div className="kit-icon">
                        <EFSafer />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter2_ms1')}</div>
                </div>
                <div className="kit-item kit-2">
                    <div className="kit-icon">
                        <EFPowerLoss />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter2_ms3')}</div>
                </div>
            </div>
            <div className="kit-inter3">
                <div className="kit-item">
                    <div className="kit-icon">
                        {videoEnterA && (
                            <EFVideo sources={['/video/mm100m/12v.webm', '/video/mm100/12v.mp4']} className="video_high_temp" width={588} height={400} />
                        )}
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter3_ms1')}</div>
                    <div className="kit-temperature">
                        {videoEnterA && (
                            <EFVideo
                                sources={['/video/mm100m/high_temp.webm', '/video/mm100/high_temp.mp4']}
                                className="video_low_temp"
                                width={41}
                                height={54}
                            />
                        )}
                    </div>
                </div>
                <div className="kit-item">
                    <div className="kit-icon">
                        <EFPic name={['48v.webp', '48v.jpg']} className="fullImgs" alt={t('presale.product.kitI_inter3_ms2')} />
                    </div>
                    <div className="kit-ms">{t('presale.product.kitI_inter3_ms2')}</div>
                    <div className="kit-temperature">
                        {videoEnterA && (
                            <EFVideo sources={['/video/mm100m/low_temp.webm', '/video/mm100/low_temp.mp4']} className="video" width={35} height={54} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
